<div class="comment">
  @let posterVariable = poster();
  <div class="img-holder">
    <img [src]="posterVariable | userAvatar" [alt]="posterVariable?.fname+' '+posterVariable?.lname">
  </div>
  <div class="content-holder">
    @if(posterVariable) {
      <p class="name">{{posterVariable.fname+' '+posterVariable.lname}}</p>
    }
          <div class="d-flex flex-column">
            <textarea
              class="form-control md-textarea pt-1"
              id="commentTextArea"
              [rows]="rows()"
              name="message"
              [disabled]="loading() || loadingTranslation() || disabled()"
              [(ngModel)]="message"
              (ngModelChange)="onMessageChange()"
              placeholder="{{'common.write_something_here' | transloco}}">
            </textarea>
             <div class="button-group mt-2 align-self-end">
              @for(pair of translatablePairs(); track pair){
                <button class="btn btn-secondary btn-sm" (click)="sendForTranslation(pair)" [disabled]="!message || loading() || loadingTranslation() || disabled()">
                  <span class="mr-1">{{ 'content_management.translate' | transloco }}</span>
                  <span>{{pair.source_lang.name}}</span>
                  <span class="fa-solid fa-arrow-right mx-2"></span>
                  <span>{{pair.target_lang.name}}</span>

                </button>
              }
                <button
                (click)="doPostComment()"
                class="btn btn-primary btn-sm"
                [disabled]="!message || loading() || loadingTranslation() || disabled()">
                @if(loading()){
                  <span>
                    <span class="fa-solid fa-arrow-rotate-right fa-spin"></span>
                  </span>
                }
                <span>{{ 'common.post_a_comment' | transloco }}</span>
              </button>
             </div>
          </div>
      <hr>
  </div>
</div>